import { render } from "./UsersTopList.vue?vue&type=template&id=d643a0a2&scoped=true"
import script from "./UsersTopList.vue?vue&type=script&lang=js"
export * from "./UsersTopList.vue?vue&type=script&lang=js"

import "./UsersTopList.vue?vue&type=style&index=0&id=d643a0a2&scoped=true&lang=css"
import "../../assets/css/staff-users-top.css?vue&type=style&index=1&id=d643a0a2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d643a0a2"]])

export default __exports__